<template>
  <AccessHandler
    :requiredRoleGroups="[roleGroup]"
    @accessChanged="(a: boolean) => (hasAccess = a)"
  />
  <div data-cy="rfr-assignments-page">
    <MasterPage>
      <template v-if="!isMobile() && hasAccess" v-slot:content>
        <header class="page__header--container clearfix">
          <h1 class="page__title--text pull-left" data-cy="page-title">
            ASSIGNMENTS<small
              >CONFIDENTIAL: For RFR Use Only - Do Not Disclose.</small
            >
          </h1>
        </header>
        <AssignmentsTable />
        <GlobalFooter />
      </template>
      <template v-else-if="hasAccess" v-slot:content>
        <RfrAssignmentsMobileView />
        <GlobalFooter />
      </template>
    </MasterPage>
  </div>
</template>

<script setup lang="ts">
import MasterPage from "../MasterPage.vue";
import GlobalFooter from "@/views/GlobalFooter.vue";
import RfrAssignmentsMobileView from "./RfrAssignmentsMobileView.vue";
import { isMobile } from "../../shared/helpers/mobileHelper";
import AssignmentsTable from "./AssignmentsTable.vue";
import AccessHandler from "@/shared/access/AccessHandler.vue";
import { UserRoles as Roles } from "@/Domain/UserRoles";
import { ref } from "vue";
import type { RoleGroup } from "@/shared/access/RoleGroups";

const roleGroup = {
  roles: Roles.ROLES_ALL_RFR,
} as RoleGroup;

const hasAccess = ref<boolean>(false);
</script>
